<template>
  <div v-bind:class="{
    'main-button-wrapper': true,
    'button-theme-solid-blue': theme === 'solid-blue',
    'button-theme-solid-white': theme === 'solid-white',
  }">
    <div class="svg-container d-flex justify-content-center align-items-center h-100">
      <div class="arrow-one">
        <ArrowForwardIcon/>
      </div>
      <div class="arrow-two">
        <ArrowForwardIcon v-if="theme === 'solid-blue'" :arrow-color="'white'"/>
        <ArrowForwardIcon v-if="theme === 'solid-white'" :arrow-color="'blue'"/>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowForwardIcon from "@/components/Common/Icons/ArrowForwardIcon.vue";

export default {
  name: "CircleButton",
  components: {ArrowForwardIcon},
  props: {
    buttonText: {
      type: String
    },
    theme: {
      type: String
    },
    size: {
      type: String
    }
  },
}
</script>

<style lang="scss" scoped>
.main-button-wrapper {

  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  font-size: 10px;
  font-family: $font-bold;
  text-align: center;
  overflow: hidden;
  width: 100px;
  height: 100px;

  &:hover {
    transition: 0.3s ease-in-out;

    .arrow-one {
      transform: translateX(50%);
    }

    .arrow-two {
      transform: translateX(250%);
    }
  }

  .arrow-one {
    transform: translateX(-250%);
    transition: 0.3s ease-in-out;
  }

  .arrow-two {
    transform: translateX(-50%);
    transition: 0.3s ease-in-out;
  }

}

.button-theme-solid-blue {
  background: $color-blue-accent;

  &:hover {
    background: $color-blue-secondary;
  }
}

.button-theme-solid-white {
  background: $color-white;

  &:hover {
    background: $color-blue-accent;
  }
}


</style>
